
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mortgage",
      function () {
        return require("private-next-pages/mortgage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mortgage"])
      });
    }
  